$bog_vmap_app_inspect_row $mol_form_field
	sign \
	owner \
	inherited false
	value? $mol_tree2_empty
	binds /string
	nodes *
	keyed? false
	changeable? false
	drop? null
	editable true
	frozen \
	note \
	share_able* false
	share_mark* \
	share*? null
	share_unshare*? null
	name <= sign
	bid <= owner
	label /
		^
		<= Tools $mol_row
			sub <= tools /$mol_view
	control <= Value $bog_vmap_app_inspect_value
		tree? <=> value?
		binds <= binds
		nodes <= nodes
		note <= note
		path <= path \
		share_able* <= share_able*
		share_mark* <= share_mark*
		share*? <=> share*?
		share_unshare*? <=> share_unshare*?
		editable <= editable
	Frozen $mol_status
		status <= frozen
	Key $mol_check
		title \*
		hint \Много значений по ключу
		checked? <=> keyed?
		enabled <= editable
	Next $mol_check
		title \?
		hint \Изменяемое
		checked? <=> changeable?
		enabled <= editable
	Share $mol_button_minor
		title \общее
		hint \Вынести значение в общее: оно объявится один раз, здесь останется ссылка
		click? <=> share_click? null
		enabled <= editable
	Unshare $mol_button_minor
		title \своё
		hint \Отвязать от общего значения и вернуть его сюда как своё
		click? <=> unshare_click? null
		enabled <= editable
	Mark $mol_view
		sub <= mark_sub /$mol_view_content
	drop_hint \Убрать свойство из документа
	Drop $mol_button_minor
		title \✕
		hint <= drop_hint
		click? <=> drop?
		enabled <= editable
